import SuggestionsView from './suggestions-carousel-view'

export default SuggestionsView
